import { render, staticRenderFns } from "./OptionHealthAttorneysBackupWorkTogetherYN.vue?vue&type=template&id=65263dc8"
import script from "./OptionHealthAttorneysBackupWorkTogetherYN.vue?vue&type=script&lang=js"
export * from "./OptionHealthAttorneysBackupWorkTogetherYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports